/**
 * @file   src\components\CAMenu.tsx
 * @brief  This component used to create CA menu.
 * @date   Aug, 2024
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */

import { MenuItem, useNavigate, useLocation } from './ThirdPartyComponents';
import ManageScheduleIcon from '../assests/icons/ManageSchedule';
import { CARoutePath } from '../utils/enums';
import Strings from '../assests/strings/Strings.json';
import { checkPathMatched } from '../utils/helper';
import { IMenuItemProp } from '../interfaces/generalInterface';

const CAMenu = ({ toggleMenu }: IMenuItemProp) => {
  // Navigate object creation.
  const navigate = useNavigate();

  /* Create location object to access location info. */
  const location = useLocation();

  // Menu navigation event.
  const navigateUrl = (url: string) => {
    navigate(url);
    toggleMenu(false);
  };

  return (
    <MenuItem
      active={checkPathMatched([CARoutePath.Home, CARoutePath.Schedule, CARoutePath.ShiftDetails], location?.pathname)}
      icon={<ManageScheduleIcon />}
      onClick={() => navigateUrl(CARoutePath.Home)}
    >
      {Strings.Menu.ManageSchedules}
    </MenuItem>
  );
};

export default CAMenu;
